import React, { Component } from "react";
import { FormValidate } from "../../../../components/formValidate";
import CustomButton from "../../../../components/inputs/button";
import DatePickerField from "../../../../components/inputs/datepicker";
import TextField from "../../../../components/inputs/textfield";
import Snackbar from "../../../../components/snackbar/snackbar";

import Loader from "../../../../components/loader/loader";
import {
  admin_policy_add,
  admin_policy_edit,
} from "../../admin.api";
import "./dialog.css";
import TextEditer from "../../../../components/inputs/texteditor";

let required = [
  "title",
  "title_ma",
  "description",
  "description_ma"

];
const tomorrow = new Date();
tomorrow.setDate(tomorrow.getDate() + 1);

class Dialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
      formData: props.formData,
      edit: props.edit,
      isActive: false,
      submitted: false,
      snackMessage: "",
      isSnackError: false,
      snackOpen: false,
      fileError: false,
      fileChange: false,
    };
  }

  componentWillReceiveProps = (props) => {
    this.setState({
      open: props.open,
      edit: props.edit,
      formData: props.formData,
    });
  };
  handleEditorChange = (value, fieldName) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [fieldName]: value,
      },
    });
  };

  handleChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;

    this.setState({ formData: { ...this.state.formData, [name]: value } });
  };
  handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const size = file.size;
    const type = file.name.split(".").pop().toLowerCase();
    const mb = size / (1024 * 1024); 

    if (type === "pdf") {
      if (mb < 10) {
        this.setState({
          fileError: false,
          formData: {
            ...this.state.formData,
            file: file,
            file_name: file.name,
          },
        });
      } else {
        this.setState({
          fileError: true,
          snackMessage: "File size should not exceed 10MB",
          formData: { ...this.state.formData, file: null, file_name: null },
          isSnackError: true,
          snackOpen: true,
        });
        e.target.value = null;
      }
    } else {
      this.setState({
        fileError: true,
        formData: { ...this.state.formData, file: null, file_name: null },
        snackMessage: "Only PDF files are allowed",
        isSnackError: true,
        snackOpen: true,
      });
      e.target.value = null;
    }
  };

  snackbarClose = (flag) => {
    this.setState({
      snackMessage: "",
      isSnackError: false,
      snackOpen: false,
    });
    if (!flag) {
      this.props.handleClose();
    }
  };
  handleDatePickerChange = (e, value) => {
    let date = e.value;
    if (date) {
      this.setState({
        formData: {
          ...this.state.formData,
          notification_date: date,
        },
      });
    } else {
      this.setState({
        formData: {
          ...this.state.formData,
          notification_date: null,
        },
      });
    }
  };
handleSubmit = (e) => {
  const error = FormValidate(this.state.formData, required);
  const { edit, formData } = this.state;
  e.preventDefault();

  let payload = new FormData();

  Object.keys(formData).forEach((key) => {
    const value = formData[key];

    if (key === "status") {
      return; 
    }

    if (key === "file") {
      if (typeof value !== "string" && value !== null) {
        payload.append("file", value);
      }
    } else if (key === "file_name") {
      if (value !== null) {
        payload.append("file_name", value);
      }
    } else {
      if (value !== null) {
        payload.append(key, value);
      }
    }
  });

  if (Object.keys(error).length === 0) {
    this.setState({ isActive: true });

    const apiCall = edit ? admin_policy_edit(formData?.id, payload) : admin_policy_add(payload);

    apiCall
      .then((res) => {
        this.setState({
          submitted: true,
          isActive: false,
          snackMessage: res.message,
          isSnackError: false,
          snackOpen: true,
        });
      })
      .catch((error) => {
        this.setState({
          submitted: false,
          isActive: false,
          snackMessage: error.message,
          isSnackError: true,
          snackOpen: true,
        });
      });

  } else {
    this.setState({
      submitted: false,
      snackMessage: "Please fill all mandatory fields",
      isSnackError: true,
      snackOpen: true,
    });
  }
};

  render() {
    const { submitted, formData, open, edit, isActive } = this.state;
    const { view } = this.props;
    return (
      <React.Fragment>
        {open && (
          <React.Fragment>
            <Loader open={isActive} />
            <div className="overlay">
              <div className="big-dia-scroll dialog" style={{ height: "660px" }}>
                <Snackbar
                  message={this.state.snackMessage}
                  error={this.state.isSnackError}
                  open={this.state.snackOpen}
                  close={this.snackbarClose}
                />
                <div className="row">
                  <div className="flexDisplay">
                    <div className="diaTitleCon">
                      {edit
                        ? "Edit Policies and Regulations"
                        : view
                          ? "Policies and Regulations"
                          : "Add Policies and Regulations"}
                    </div>
                    <div className="dia-close" onClick={this.props.handleClose}>
                      <div className="diaCloseCon">
                        <div className="diaClose">&#10005;</div>
                      </div>
                    </div>
                  </div>
                  <div className="tilebar d-flex justify-content-start">
                    <hr />
                  </div>
                  <form action="">
                    <div className="row book-form ">
                      <div className="content-scroll-xx2">
                        <div className="col-12">
                          <TextField

                            id="outlined-basic"
                            label="Title[Eng]"
                            variant="outlined"
                            disabled={view}
                            onChange={(e) => this.handleChange(e)}
                            value={formData?.title ?? ""}
                            name="title"
                            required
                          />
                        </div>
                        <div className="col-12">
                          <TextField
                            id="outlined-basic"
                            label="Title[Mal]"
                            name="title_ma"
                            variant="outlined"
                            disabled={view}
                            value={formData?.title_ma ?? ""}
                            onChange={(e) => this.handleChange(e)}
                            required
                          />
                        </div>
                        <div className="col-12">
                          <label className="mylabel">
                            Description[Eng]
                          </label>
                          <TextEditer
                            value={formData?.description ?? ""}
                            onChange={(e) => this.handleEditorChange(e, "description")}
                            disabled={view}
                            name="description"
                            required
                          />
                        </div>
                        <div className="col-12">
                          <label className="mylabel">
                            Description[Mal]
                          </label>
                          <TextEditer
                            value={formData?.description_ma ?? ""}
                            onChange={(e) => this.handleEditorChange(e, "description_ma")}
                            disabled={view}
                            name="description_ma"
                            required
                          />
                        </div>
                        <div className="col-12">
                          <TextField
                            id="outlined-basic"
                            label="Link"
                            name="link"
                            variant="outlined"
                            disabled={view}
                            value={formData?.link ?? ""}
                            onChange={(e) => this.handleChange(e)}
                          // required
                          />
                        </div>
                        <div className="col-12">
                          <TextField
                            type="file"
                            // view="straight"
                            id="outlined-basic"
                            onChange={(e) => this.handleFileChange(e)}
                            label="File"
                            disabled={view}
                            fileName={formData?.file_name}
                            accept=".pdf,.docx,.doc"
                          // required
                          />
                          {this.state.fileError && (
                            <div className="file-up-helper text-start">
                              *Upload only .pdf and Size
                              should be less than 10MB
                            </div>
                          )}
                        </div>
                      </div>
                      {!view && (
                        <div className="col-12">
                          <CustomButton
                            label={edit ? "Update" : "Add"}
                            disabled={submitted}
                            onClick={(e) => this.handleSubmit(e)}
                          />
                        </div>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default Dialog;
